import React,{Component} from 'react';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Button from 'material-ui/Button';
import { withStyles, MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import green from 'material-ui/colors/green';
//import axios from 'axios'
import Cookies from 'js-cookie'
import { CircularProgress } from 'material-ui/Progress';
import { getJSON } from 'jquery'

const theme = createMuiTheme({
    palette: {
        primary: green,
    },
});

class  LoginForm extends Component{
        constructor(){
            super();
            this.state={
                name:'',
                password:'',
                load:false,
                loginError:false,
                login:this.isLogin()
            }
        }
    isLogin(){
        if (Cookies.get('user')==null){
            console.log('nb'+Cookies.get('user')+'false');
        return false
        }else{
            console.log("nb"+Cookies.get('user'));
        return true
        }
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: event.target.value});
        console.log(this.state)
    }
    handleSubmit(event){
            this.setState({
                load:true
            })
            const {name,password}=this.state;
            getJSON('http://123.207.90.121:8080/newBlog/api/login',{name:name,password:password}).then(response=>{
                const data=response.data;
                if (response.code==1){
                        Cookies.set('user',data.userName);
                        this.props.handleLogin();
                        this.setState({
                            load:false,
                            login:true
                        })
                    console.log("登录成功"+Cookies.get('user'))
                }else {
                    this.handleLoginError();
                    console.log("登录失败")
                }
                this.setState({load:false})
                return true;
            },error=> {
                this.setState({load:false})
                this.handleLoginError();
            }).then((flag)=>{this.props.handleStartRoute()})

    }
    handleLoginError(){
            this.setState({loginError:!this.state.loginError})
        setInterval(this.handleLoginError.bind(this),3000)
    }


    render(){

            if (this.state.load){
                return (<table valign="medium" align="center" style={{width:'100%',height:'100%'}}>
                <tbody><tr><td align="center"><CircularProgress style={{color:'green'}} />
                    </td></tr></tbody></table>)
            }
        if (this.state.login){
            return (
                <div style={{textAlign:'center',marginTop:'50px',marginBottom:'10px'}}>
                    <table valign="bottom" style={{display:'inline',marginTop:'10px',marginBottom:'10px'}}>
                        <tbody>
                        <tr valign="top">
                            <td className={'blok'} onClick={this.props.writeNovel}>
                                <i className="material-icons" style={{color:'#16c2d1',fontSize:35,display:'block',margin:'10px'}} >
                                    library_books</i>
                                <span style={{color:'#16c2d1',fontSize:'10px',display:'block',margin:'20px 8px 20px'}}>WRITE NOVEL</span>
                            </td>
                            <td className={'blok'} onClick={this.props.writeNovelChapter}>
                                <i className="material-icons" style={{color:'#5ac73e',fontSize:35,display:'block',margin:'10px'}} >
                                    textsms</i>
                                <span style={{color:'#5ac73e',fontSize:'10px',display:'block',margin:'20px 13px 20px'}}>WRITE NOVEL CHAPTER</span>
                            </td>
                            <td className={'blok'} onClick={this.props.writeBlog}>
                                <i className="material-icons" style={{color:'#d11bc9',fontSize:35,display:'block',margin:'10px'}} >
                                    settings</i>
                                <span style={{color:'#d11bc9',fontSize:'10px',display:'block',margin:'20px 4px 20px'}}>WRITE BLOG</span>
                            </td>
                            <td className={'blok'} onClick={this.props.writeProject}>
                                <i className="material-icons" style={{color:'#ffa203',fontSize:35,display:'block',margin:'10px'}} >
                                    accessibility</i>
                                <span style={{color:'#ffa203',fontSize:'10px',display:'block',margin:'20px 10px 20px'}}>WRITE PROJECT</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            )
        }
        return(
            <MuiThemeProvider theme={theme}>
            <div style={{textAlign:'Center',overflow:'hidden'}}>
                <h1 style={{color:'black'}}><b>LOGIN</b></h1>
            <div style={{margin:'10px'}}>
                <FormControl>
                <InputLabel htmlFor="name" >NAME</InputLabel>
                <Input type='text'
                    id="name"  onChange={this.handleChange.bind(this)} name="name"
                    startAdornment={
                        <InputAdornment position="start">
                            <i className="material-icons">account_circle</i>
                        </InputAdornment>
                    }
                />
                </FormControl>
            </div>
                <div style={{margin:'10px'}}>
            <FormControl>
                <InputLabel htmlFor="password" >PASSWORD</InputLabel>
                <Input type='password' name="password"
                    id="password" onChange={this.handleChange.bind(this)}
                    startAdornment={
                        <InputAdornment position="start">
                            <i className="material-icons">zoom_in</i>
                        </InputAdornment>
                    }
                />
            </FormControl>
                </div>
                <div style={{margin:'30px'}}>
                    <FormControl>

                        {this.state.loginError?
                            <Button size="large" style={{backgroundColor:'#ac2d27'}}  >
                                Login Failed
                            </Button>
                            :
                            <Button size="large" style={{backgroundColor:'#5ac73e'}} onClick={this.handleSubmit.bind(this)} >
                                SUBMIT
                            </Button>
                        }

                    </FormControl>
                </div>
            </div>
            </MuiThemeProvider>

        )
    }
}
export default LoginForm;


// WEBPACK FOOTER //
// ./src/Compent/SliderBar/LoginForm.js